module.exports = __webpack_public_path__ + "static/media/R1.80fdf0f9.jpg";